import { render, staticRenderFns } from "./editasset.vue?vue&type=template&id=0be46114&scoped=true"
import script from "./editasset.js?vue&type=script&lang=js&external"
export * from "./editasset.js?vue&type=script&lang=js&external"
import style0 from "./editasset.vue?vue&type=style&index=0&id=0be46114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be46114",
  null
  
)

export default component.exports